import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getMaterialsOutsourcingAvailableColumns } from './api';

export const path = '/calculator-tariff/materials-outsourcing/list';

const PageMaterialsOutsourcing: React.FC = (props) => {
  const MaterialsOutsourcing = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getMaterialsOutsourcingAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <MaterialsOutsourcing {...props} />;
};

export default PageMaterialsOutsourcing;
